export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de productores"])},
          "total_exported": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Total exportado (Kg)"])},
          "title_monthly": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rendimiento mensual"])},
          "title_weekly": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rendimiento semanal"])}
        }
      }
    }
  })
}